// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"472":"5dc75405","704":"53173b56","724":"7b06471d","835":"e6b5bde4"}[chunkId] + ".css";
};